import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
  COURSES,
  CREATE_CHILD,
  DASHBOARD,
  MESSAGES_ROUTES,
  MY_ACCOUNT_ROUTES,
  MY_APPOINTMENT_ROUTES,
  MY_SKIN_ROUTES,
  NOT_FOUND_PAGE,
  NOTIFICATIONS_ROUTES,
  PROVIDERS_ROUTES,
  TEST_KITS_MANAGEMENT_ROUTES,
} from 'utilities/routes';
import PatientLayout from './Layout';
import NotFoundPage from '../NotFoundPage';

import {
  CoursesRoutes,
  CreateChild,
  DashboardPage,
  ManageTestKitsRoutes,
  MyAppointmentsRoutes,
  MyAccountRoutes,
  MyMessagesRoutes,
  MySkinRoutes,
  NotificationsRoutes,
  ProvidersViewSelectionRoutes,
} from './patientLoaders';
import ProtectedRoutesModal from '../../components/ProtectedRoutesModal/ProtectedRoutesModal';
import { ProtectedModalProvider } from './ProtectedModalContext';

const PatientRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <ProtectedModalProvider>
            <PatientLayout />
          </ProtectedModalProvider>
        }
      >
        <Route
          path={DASHBOARD}
          element={
            <ProtectedRoutesModal>
              <DashboardPage />
            </ProtectedRoutesModal>
          }
        />
        <Route path={MESSAGES_ROUTES} element={<MyMessagesRoutes />} />
        <Route
          path={MY_SKIN_ROUTES}
          element={
            <ProtectedRoutesModal>
              <MySkinRoutes />
            </ProtectedRoutesModal>
          }
        />
        <Route
          path={TEST_KITS_MANAGEMENT_ROUTES}
          element={
            <ProtectedRoutesModal>
              <ManageTestKitsRoutes />
            </ProtectedRoutesModal>
          }
        />
        <Route
          path={`${COURSES}/*`}
          element={
            <ProtectedRoutesModal>
              <CoursesRoutes />
            </ProtectedRoutesModal>
          }
        />
        <Route path={MY_ACCOUNT_ROUTES} element={<MyAccountRoutes />} />
        <Route
          path={CREATE_CHILD}
          element={
            <ProtectedRoutesModal>
              <CreateChild />
            </ProtectedRoutesModal>
          }
        />
        <Route path={NOTIFICATIONS_ROUTES} element={<NotificationsRoutes />} />
        <Route
          path={MY_APPOINTMENT_ROUTES}
          element={
            <ProtectedRoutesModal>
              <MyAppointmentsRoutes />
            </ProtectedRoutesModal>
          }
        />
        <Route
          path={PROVIDERS_ROUTES}
          element={
            <ProtectedRoutesModal manualOpenOnly>
              <ProvidersViewSelectionRoutes />
            </ProtectedRoutesModal>
          }
        />
        <Route path={NOT_FOUND_PAGE} element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to={DASHBOARD} replace />} />
      </Route>
    </Routes>
  );
};

export default PatientRoutes;
